import axios from "axios";
import { ROOT_URL } from "../helper/Config";

export const fetchQualificationQuestions = (params, callback) => {
  axios
    .get(`${ROOT_URL}/qualification/questions`, { params })
    .then(response => callback(response))
    .catch(error => callback(error.response || error));
};

export const saveQualificationResponse = (data, callback) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };

  axios
    .post(`${ROOT_URL}/qualification/responses`, data, config)
    .then(response => callback(response))
    .catch(error => callback(error.response || error));
};

export const checkQualificationCompletion = (params, callback) => {
  axios
    .get(`${ROOT_URL}/qualification/check-completion`, { params })
    .then(response => callback(response))
    .catch(error => callback(error.response || error));
};
